import React from "react";
import PrimaryBTN from "../BTN/primaryBTN";
import "../../styles/page404.css";
import { withNamespaces } from "react-i18next";

const Page404 = ({ t }) => {
  return (
    <section className="container page404 marginB_section">
      <div className="row">
        <div className="col-5 text-end">
          <div className="err">4</div>
        </div>
        <div className="col-2 my-auto text-center">
          <i className="far fa-question-circle fa-spin"></i>
        </div>
        <div className="col-5 text-start">
          <div className="err2">4</div>
        </div>
      </div>
      <p className="text-center text404">
        {t('modulePage404:P')}
      </p>

      <PrimaryBTN
        alinhar="text-center"
        novaClass="testemunho"
        link="/"
        title={t('moduleBotoes:B7.Title')}
        texto={t('moduleBotoes:B7.B')}
      />
    </section>
  );
};
export default withNamespaces()(Page404);